export default __webpack_public_path__ + "static/media/whats-icon.e5952e7b.svg";